module.exports = __webpack_public_path__ + "static/media/jerry.a46fa992.png";